<script lang="ts" setup>
  import { ref, computed, type Ref } from 'vue';
  import { useWishlistProducts } from '$storefront';

  const props = defineProps({
    variant: { type: Number, required: true },
  });

  const variants: Ref<number[]> = useWishlistProducts();
  const open = ref(false);

  const saved = computed(() => {
    return variants.value.includes(props.variant);
  });
</script>
<template>
  <div class="wishlist" @click.prevent.stop="open = true">
    <slot v-bind="{ saved }">
      <SfButton :class="{ saved }" class="wishlist__button" rounded small square transparent>
        <template #after>
          <SfIconHeartFill v-if="saved" />
          <SfIconHeart v-else />
        </template>
      </SfButton>
    </slot>
    <SfModal v-model:open="open">
      <SfModalHeader v-model:open="open">
        {{ $t('Dodaj do ulubionych') }}
      </SfModalHeader>
      <WishlistPickerModal :variant="variant" @saved="open = false" />
    </SfModal>
  </div>
</template>
<style scoped lang="scss">
  @use "$assets/mixins/media";

  .wishlist {
    display: contents;
    font-size: 1.125rem;

    &__button {
      &:hover {
        color: var(--color-primary);
      }

      &.saved {
        color: var(--danger-color);

        &:hover {
          color: var(--danger-color-hover);
        }
      }
    }
  }
</style>
